import React from 'react'
import Swal from 'sweetalert2'


const SwalError = (isError) => {
    
    const { icon,text } = ({ ...isError, isError })
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })

    const MyToast = Toast.fire({
        icon: `${icon}`,
        title: `${text}`,
      })

    return (
        <>
            {MyToast}
        </>
    )
}

export default SwalError

